const baseURL = import.meta.env.VITE_API_BASE_URL || 'https://api.shewobili.cc'

export interface HealthPayload {
  data: { status: string; version: string; database?: string }
  meta: { request_id: string }
}

export async function getReadiness(): Promise<HealthPayload> {
  const response = await fetch(`${baseURL}/health/ready`, {
    credentials: 'include',
    cache: 'no-store',
    headers: { Accept: 'application/json' }
  })
  if (!response.ok) throw new Error(`HTTP ${response.status}`)
  return response.json() as Promise<HealthPayload>
}

